import { gql } from "@apollo/client";

export const camerasFirmwareQuery = gql`
    query CamerasFirmwareAdmin($page: Int) {
        camerasFirmwareAdmin(page: $page) {
            nodes {
                id
                name
            }
            totalCount
            nextPage
            previousPage
            totalPages
        }
    }
`;
